'use client';

import React from "react";

const stacks = "/assets/stack.svg";
const rightImg = "/assets/logo2.webp";
function ReqDemo() {
  const handleButtonClick = () => {
    window.open("https://digitalcommandcenter.io/signup", "_blank");
  };

  return (
    <div className="relative pt-36 overflow-hidden h-[700px]">
      <div className="relative p-px rounded-2xl overflow-hidden group z-10 mx-4 sm:mx-16 md:mx-28 2xl:mx-auto max-w-[1280px]">
        <div className="absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),#555_60%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150"></div>
        <div className="bg-color-98 rounded-2xl justify-between items-start gap-[27px] flex overflow-hidden relative">
          <div className="p-4 sm:p-6 md:p-8 lg:p-10 w-[100%] lg:w-[60%] z-10">
            <div className="text-color-1 text-3xl lg:text-4xl font-medium leading-[3rem]">
              Ready to transform your organizational operations.
            </div>
            <div className="text-color-2 text-xl lg:text-2xl font-medium mt-6 mb-12">
              Smart management for companies and teams.
            </div>
            <button
              onClick={handleButtonClick}
              className="px-10 py-4 bg-[linear-gradient(180deg,_var(--accent-light),_var(--accent-dark))] rounded-full justify-center items-center gap-[12.94px] inline-flex overflow-hidden cursor-pointer relative transition-all duration-500 hover:px-16 group/nested"
            >
              <div className="absolute inset-0 bg-[linear-gradient(180deg,_#fff,_#fff)] opacity-0 group-hover/nested:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute -left-5 w-5 h-5 bg-color-1 rounded-full group-hover/nested:left-72 group-hover/nested:bg-color-100 transition-all duration-500"></div>
              <div className="relative z-10 text-color-100 text-xl font-medium text-nowrap">
                Free Trial
              </div>
            </button>
          </div>
          <div className="absolute right-0 -bottom-20 lg:-bottom-20 opacity-20 md:opacity-40 lg:opacity-100 blur-md lg:blur-0 ">
            <img
              loading="lazy"
              src={stacks}
              alt="stack"
              className="bg-blend-overlay"
            />
          </div>
        </div>
      </div>

      <div
        className="absolute -right-32 top-12 w-full lg:w-1/2 h-[750px] bg-no-repeat rounded-3xl overflow-hidden grayscale"
        style={{
          backgroundImage: `
            url('${rightImg}')`,
          backgroundSize: "contain, 100% 100%, 100% 100%, 100% 100%, 100% 100%",
          backgroundBlendMode: "overlay",
        }}
      ></div>
    </div>
  );
}

export default ReqDemo;
